import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/menu/Sample.svg'
import _imports_1 from '@/assets/menu/Users.svg'
import _imports_2 from '@/assets/menu/Banner.svg'
import _imports_3 from '@/assets/menu/News.svg'
import _imports_4 from '@/assets/menu/Files.svg'
import _imports_5 from '@/assets/menu/Notifications.svg'
import _imports_6 from '@/assets/menu/Shared.svg'
import _imports_7 from '@/assets/menu/Campaigns.svg'
import _imports_8 from '@/assets/menu/Advances.svg'
import _imports_9 from '@/assets/menu/Payments.svg'
import _imports_10 from '@/assets/menu/Events.svg'


const _hoisted_1 = { class: "wrapper-menu" }
const _hoisted_2 = { class: "options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showReferences)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/sample-book",
            class: "option"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                class: "icon sample"
              }, null, -1),
              _createElementVNode("span", { class: "option-name" }, "Muestrario", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showUsers)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/users",
            class: "option"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "",
                class: "icon users"
              }, null, -1),
              _createElementVNode("span", { class: "option-name" }, "Usuarios", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showBanners)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: "/banners",
            class: "option"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "",
                class: "icon banner"
              }, null, -1),
              _createElementVNode("span", { class: "option-name" }, "Banners", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showNews)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 3,
            to: "/news",
            class: "option"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_3,
                alt: "",
                class: "icon news"
              }, null, -1),
              _createElementVNode("span", { class: "option-name" }, "Noticias", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showFiles)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 4,
            to: "/files",
            class: "option"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: _imports_4,
                alt: "",
                class: "icon files"
              }, null, -1),
              _createElementVNode("span", { class: "option-name" }, "Archivos", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      false
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 5,
            to: "/notifications",
            class: "option"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("img", {
                src: _imports_5,
                alt: "",
                class: "icon notifications"
              }, null, -1),
              _createElementVNode("span", { class: "option-name" }, "Notificaciones", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showSharedReferences)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 6,
            to: "/shared-samples",
            class: "option"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createElementVNode("img", {
                src: _imports_6,
                alt: "",
                class: "icon shared"
              }, null, -1),
              _createElementVNode("span", { class: "option-name" }, "Muestras compartidas", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showCampaigns)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 7,
            to: "/campaigns",
            class: "option"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createElementVNode("img", {
                src: _imports_7,
                alt: "",
                class: "icon campaigns"
              }, null, -1),
              _createElementVNode("span", { class: "option-name" }, "Campañas", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showAdvances)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 8,
            to: "/advances",
            class: "option"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createElementVNode("img", {
                src: _imports_8,
                alt: "",
                class: "icon advances"
              }, null, -1),
              _createElementVNode("span", { class: "option-name" }, "Anticipos", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showPayments)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 9,
            to: "/payments",
            class: "option"
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createElementVNode("img", {
                src: _imports_9,
                alt: "",
                class: "icon payments"
              }, null, -1),
              _createElementVNode("span", { class: "option-name" }, "Pagos", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showEvents)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 10,
            to: "/events",
            class: "option"
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createElementVNode("img", {
                src: _imports_10,
                alt: "",
                class: "icon events"
              }, null, -1),
              _createElementVNode("span", { class: "option-name" }, "Eventos", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}